export const getConfig = {
  clientId: process.env["REACT_APP_AUTH_CLIENT_ID"],
  clientSecret: process.env["REACT_APP_AUTH_CLIENT_SECRET"],
  baseUrl: process.env["REACT_APP_PROXY_HOST"],
  masterUserName: process.env["REACT_APP_MASTERUSER_USERNAME"],
};